export function stripSignature(urlPart: string): string {
  return urlPart.replace(/^.*\/[^/]+\/\d+\//, "");
}
